import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';

const DropDown = styled.ul`
  list-style: none;
`;

const DropDownLabelContainer = styled.div`
  cursor: pointer;
`;

export interface Props {
  name?: string;
  children: ReactNode;
}

const Group = (props: Props) => {
  const { children } = props;

  return (
    <DropDownLabelContainer>
      <DropDown>{children}</DropDown>
    </DropDownLabelContainer>
  );
};

export default Group;
